import { createContext } from 'react';
export var ExperienceTrackerContext = /*#__PURE__*/createContext({
  abort: function abort() {},
  fail: function fail() {},
  start: function start() {},
  succeed: function succeed() {},
  stopOnError: function stopOnError() {},
  subscribe: function subscribe() {
    return function () {};
  }
});